<template>
    <b-row>
        <!--            col-xl-7 TODO 42006-->
        <csp-desktop-info-card ref="infoCard"
            class="col-xl-12 col-12"
            :form-context="repairSequencePlanFormContext"
            icon="inticon-repair"
            title="Reparaturablaufplan"
            @save="saveRepairFormData">
            <b-row v-for="subformIdentifier in
                subformIdentifiers" :key="subformIdentifier">
                <b-col cols="3">
                    <csp-desktop-info-card-element
                        :form-context="repairSequencePlanFormContext"
                        label="Bezeichnung"
                        property="type"
                        :required="true"
                        :subform-identifier="subformIdentifier"
                        type="autocomplete"
                        @change="handleTypeChange(subformIdentifier)"/>
                </b-col>
                <b-col cols="3">
                    <!--                    TODO 42006 description and type in same b-col col="4" -->
                    <csp-desktop-info-card-element
                        v-if="needsFurtherDescription(subformIdentifier)"
                        :form-context="repairSequencePlanFormContext"
                        label="Beschreibung"
                        property="description"
                        :required="true"
                        :subform-identifier="subformIdentifier"
                        type="text"/>
                </b-col>
                <b-col cols="2">
                    <csp-desktop-info-card-element
                        :form-context="repairSequencePlanFormContext"
                        label="Datum"
                        :max-date="null"
                        property="startDate"
                        :required="false"
                        :subform-identifier="subformIdentifier"
                        type="datepicker"/>
                </b-col>
                <!--                TODO 42006 cols="2" for time -->
                <b-col cols="1">
                    <csp-desktop-info-card-element
                        v-if="isStartTimeEditable(subformIdentifier)"
                        :form-context="repairSequencePlanFormContext"
                        label="Uhrzeit"
                        property="startTime"
                        :required="false"
                        step="60"
                        :subform-identifier="subformIdentifier"
                        type="time"/>
                </b-col>
                <b-col cols="2">
                    <csp-desktop-info-card-element
                        v-if="isInEditMode"
                        class="align-content-end"
                        :form-context="repairSequencePlanFormContext"
                        :hide-label="true"
                        label="PDF Ausgabe"
                        property="addToDocument"
                        :required="false"
                        :subform-identifier="subformIdentifier"
                        type="checkbox"/>
                    <div v-else-if="!getAddToDocument(subformIdentifier)"
                        class="info-card-element align-content-center">
                        Keine PDF Ausgabe
                    </div>
                </b-col>
                <!--                TODO 42006 cols="2"-->
                <b-col
                    v-if="repairSequencePlanFormContext.isInEditMode"
                    cols="1"
                    style="padding-top: 16px; height: 64px; padding-bottom: 15px">
                    <b-button class="mr-1" variant="secondary" @click="deleteStep(subformIdentifier)">
                        <i class="inticon inticon-trash"/>
                    </b-button>
                    <b-button variant="primary"
                        @click="addStep(repairSequencePlanFormContext.
                            form.getDataOfSubform(subformIdentifier).sortOrder)">
                        <i class="inticon inticon-add"/>
                    </b-button>
                </b-col>
            </b-row>
            <b-row class="mt-5">
                <csp-desktop-info-card-element
                    class="col-3"
                    :form-context="repairSequencePlanFormContext"
                    label="Reparaturdatum"
                    :max-date="null"
                    property="repairAppointmentDate"
                    :required="false"
                    type="datepicker"/>
                <csp-desktop-info-card-element
                    class="col-9"
                    :form-context="repairSequencePlanFormContext"
                    label="Bemerkungen"
                    property="remarksRepairSequencePlan"
                    :required="false"
                    type="autogrowtextarea"/>
            </b-row>
            <b-row v-if="!repairSequencePlanFormContext?.isInEditMode">
                <b-col cols="6"/>
                <b-col class="text-right" cols="6">
                    <b-button variant="primary" @click="createPDF">
                        PDF erzeugen
                    </b-button>
                    <b-button variant="primary" @click="sendNotification">
                        An Kanzlei / SD senden
                    </b-button>
                    <external-service-provider-action
                        v-if="repairSequencePlanFormContext.permissions.canDocumentExternalAction"
                        :record-id="recordId"
                        @saved="reloadSteps()"/>
                </b-col>
            </b-row>
        </csp-desktop-info-card>

        <!--        <csp-desktop-info-card-->
        <!--            class="col-xl-5 col-12 repair-status"-->
        <!--            :full-height="false"-->
        <!--            icon="inticon-autoclaim_info"-->
        <!--            :show-buttons="false"-->
        <!--            title="Status">-->
        <!--            <div v-if="statusLoading" class="d-flex justify-content-center py-3 mb-0">-->
        <!--                <csp-loading-indicator/>-->
        <!--            </div>-->
        <!--            <b-row v-else>-->
        <!--                <b-col class="status-image text-center mb-3" cols="12">-->
        <!--                    <img :src="imageUrl"/>-->
        <!--                </b-col>-->
        <!--                <b-col v-for="(dateObj, status) in dateByStatus" :key="status" cols="2">-->
        <!--                    <div class="info-card-element repair-status-label">-->
        <!--                        <label :class="status === lastStatus ? 'active' : ''">-->
        <!--                            {{ $t('repair-status-' + status) }}-->
        <!--                        </label>-->
        <!--                        <div class="value">-->
        <!--                            {{ dateObj ? formatDate(dateObj.date) : 'tba' }}-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                </b-col>-->
        <!--            </b-row>-->
        <!--        </csp-desktop-info-card> TODO 42006-->
    </b-row>
</template>

<script>
    import {formatDate} from '@js/functions/date';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
    import Container from '@services/Container';
    import FormContext from '@desktop/components/FormContext';
    import ExternalServiceProviderDocumentation
        from '@desktop/components/record/ExternalServiceProviderDocumentation.vue';
    import '@scss/components/repair.scss';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();
    const flashMessenger = container.getFlashMessenger();

    export default {
        name: 'RecordRepair',
        components: {'external-service-provider-action': ExternalServiceProviderDocumentation},
        mixins: [FormDataMixin],
        data() {
            const recordId = parseInt(this.$route.params.recordId);
            return {
                recordId,
                dateByStatus: {},
                lastStatus: '',
                statusImageIdentifier: '',
                statusLoading: false,
                initialFormContexts: {
                    repairSequencePlanFormContext: new FormContext({
                        name: 'repair-sequence-plan',
                        reloadFields: [],
                    }),
                },
            };
        },
        computed: {
            isInEditMode() {
                return !!this.repairSequencePlanFormContext.isInEditMode;
            },
            imageUrl() {
                if (!this.statusImageIdentifier) {
                    return null;
                }
                return `/static/img/repair-sequence-plan/${this.statusImageIdentifier}.png`;
            },
            repairSequencePlanFormContext() {
                return this.initialFormContexts.repairSequencePlanFormContext;
            },
            subformIdentifiers() {
                return this.repairSequencePlanFormContext.form.getSubformIdentifiers() || [];
            },
            needsFurtherDescription() {
                return (subformIdentifier) => {
                    return !!this.getSelectedTypeInfo(subformIdentifier)?.needsFurtherDescription;
                }
            },
            isStartTimeEditable() {
                return (subformIdentifier) => {
                    return !!this.getSelectedTypeInfo(subformIdentifier)?.isStartTimeEditable;
                }
            },
            defaultAddToDocument() {
                return (subformIdentifier) => {
                    return !!this.getSelectedTypeInfo(subformIdentifier)?.defaultAddToDocument;
                }
            },
        },
        mounted() {
            this.loadForm();
            // this.loadStatus(); TODO 42006
        },
        methods: {
            formatDate,
            getAddToDocument(subformIdentifier) {
                const step = this.repairSequencePlanFormContext.form.getDataOfSubform(subformIdentifier);
                return !!step.addToDocument;
            },
            handleTypeChange(subformIdentifier) {
                const step = this.repairSequencePlanFormContext.form.getDataOfSubform(subformIdentifier);

                if (!this.isStartTimeEditable(subformIdentifier)) {
                    step.startTime = null;
                }

                if (!this.needsFurtherDescription(subformIdentifier)) {
                    step.description = '';
                }

                const initialData = this.repairSequencePlanFormContext.data[subformIdentifier]?.data.attributes;

                if (step.type !== initialData.type) {
                    // when the type is actually changed, we reset the default value for printing it to the pdf
                    step.addToDocument = this.defaultAddToDocument(subformIdentifier);
                } else {
                    // when originally selected type is (re-)selected we set addToDocument to value from DB
                    step.addToDocument = initialData.addToDocument;
                }
            },
            reloadSteps() {
                this.repairSequencePlanFormContext.isLoading++;
                this.loadForm()
                    .finally(() => {
                        this.repairSequencePlanFormContext.isLoading--
                    });
                // this.loadStatus(); TODO 42006
            },
            loadStatus() {
                this.statusLoading = true;
                recordRepository.getRepairStatus(this.recordId).then(
                    (response) => {
                        this.dateByStatus = response.data.attributes.dateByStatus;
                        this.lastStatus = response.data.attributes.lastStatus;
                        this.statusImageIdentifier = response.data.attributes.statusImageIdentifier;
                        this.statusLoading = false;
                    }
                )
            },
            async loadForm() {
                const loadFunction = () => {
                    return recordRepository.loadRepairSequencePlan(this.recordId);
                }
                await this.loadFormData(loadFunction);
            },
            addStep(afterStepOrder) {
                const loadFunction = (objectId, postData) => {
                    return recordRepository.addRepairSequencePlanStep(this.recordId, postData, afterStepOrder);
                }
                this.reloadFormData(this.repairSequencePlanFormContext, loadFunction);
            },
            deleteStep(stepIdentifier) {
                if (this.subformIdentifiers.length === 1) {
                    flashMessenger.addWarning('Der Standard-Reparaturablaufplan wurde wiederhergestellt.');
                }
                const deleteFunction = (objectId, postData) => {
                    return recordRepository.deleteRepairSequencePlanStep(this.recordId, postData, stepIdentifier);
                }
                this.reloadFormData(this.repairSequencePlanFormContext, deleteFunction);
            },
            getSelectedTypeInfo(subformIdentifier) {
                const step = this.repairSequencePlanFormContext.form.getDataOfSubform(subformIdentifier);

                const selectedType = step.type;
                const typeInfo = this.repairSequencePlanFormContext.data.typeInfo;

                if (selectedType === null || !typeInfo || typeInfo.length === 0) return null;

                return typeInfo[selectedType] || null;
            },
            saveRepairFormData() {
                const saveFunction = (objectId, postData) => {
                    return recordRepository.saveRepairSequencePlan(this.recordId, postData);
                }
                this.saveFormData(this.repairSequencePlanFormContext, saveFunction, null).finally(
                    // () => {
                    //     this.loadStatus();
                    // } // TODO 42006
                )
            },
            createPDF() {
                recordRepository.createRepairSequencePlanPDF(
                    this.recordId, this.repairSequencePlanFormContext.form.getData()
                ).then(
                    () => {
                        flashMessenger.addSuccess('Reparaturablaufplan als PDF gespeichert')
                    }
                );
            },
            sendNotification() {
                recordRepository.sendRepairSequencePlanNotification(
                    this.recordId, this.repairSequencePlanFormContext.form.getData()
                ).then(
                    (response) => {
                        const recipients = response.data.attributes.recipients;
                        if (recipients.length === 0) {
                            flashMessenger.addWarning('Es wurde keine Nachricht versendet. ' +
                                'Der verantwortliche Benutzer konnte nicht ermittelt werden.');
                        } else {
                            flashMessenger.addSuccess(
                                'Interne Benachrichtigung an folgende Benutzer versandt: ' + recipients.join(', ')
                            );
                        }
                    }
                );
            },
        },
    }
</script>
